import React, { useState, useRef } from "react";
import { Grid, Input, MenuItem, Select, InputLabel, Typography, FormGroup } from "@mui/material";
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from "@mui/material/styles";
import TextTransition, { presets } from "react-text-transition";
import { DataGrid } from '@mui/x-data-grid';
import clsx from 'clsx';
import StarIcon from '@mui/icons-material/Star';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import DateRangeIcon from '@mui/icons-material/DateRange';
import RoundaboutRightIcon from '@mui/icons-material/RoundaboutRight';
import DiscountIcon from '@mui/icons-material/Discount';
import FunctionsIcon from '@mui/icons-material/Functions';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import { useSelector } from "react-redux";


const PricingDetailsArray = ({
    center,
    edit_mode,
    total_journey, setTotalJourney,
    total_extra, setTotalExtra,
    total_extra_days, setTotalExtraDays,
    total_discount, setTotalDiscount,
    total_um, setTotalUM,
    total_transport, setTotalTransport,
    total,
    payments,
    total_commission, setTotalCommission
}) => {

    const { user: currentUser } = useSelector((state) => state.auth);

    const NoHeaderDataGrid = styled(DataGrid)(({ }) => ({ "& .MuiDataGrid-columnHeaders": { display: "none" }, "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" } }));

    const getCurrencyAsString = () => {
        switch (center ? center.currency : -1) {
            case -1:
                return "";
            case 1:
                return "€";
            case 2:
                return "£"
            case 3:
                return "$"
        }
    }

    const getTotal = () => {
        return (total_journey ? total_journey : 0) + total_extra + total_um + total_transport + total_extra_days - (total_discount ? total_discount : 0) - (total_commission ? total_commission : 0);
    }

    const getBalance = () => {
        return getTotal() - getTotalPayments()
    }

    const getTotalPayments = () => {
        return payments.reduce((accumulator, p) => {
            return accumulator + p.amount;
        }, 0);
    }

    const rows = [
        { id: 1, name: 'Weeks', amount: total_journey ? total_journey : 0, currency: getCurrencyAsString() },
        { id: 2, name: 'Pro Activities & Outings', amount: total_extra ? total_extra : 0, currency: getCurrencyAsString() },
        { id: 3, name: 'Transport', amount: total_transport ? total_transport : 0, currency: getCurrencyAsString() },
        { id: 4, name: 'Unaccompanied minor', amount: total_um ? total_um : 0, currency: getCurrencyAsString() },
        edit_mode ? { id: 5, name: 'Extra days', amount: total_extra_days ? total_extra_days : 0, currency: getCurrencyAsString() } : null,
        edit_mode ? { id: 6, name: 'Discount', amount: total_discount ? total_discount : 0, currency: getCurrencyAsString() } : null,
        edit_mode || currentUser ? { id: 7, name: 'Commission', amount: total_commission ? total_commission : 0, currency: getCurrencyAsString() } : null,
        { id: 8, name: 'Total', amount: getTotal(), currency: getCurrencyAsString() },
        edit_mode ? { id: 9, name: 'Total payments', amount: getTotalPayments(), currency: getCurrencyAsString() } : null,
        edit_mode ? { id: 10, name: 'Balance', amount: getBalance(), currency: getCurrencyAsString() } : null,
    ];

    function setAmount(params) {
        switch (params.row.id) {
            case 1:
                setTimeout(function () {
                    setTotalJourney(params.value)
                }, 1000);
                break;
            case 2:
                setTimeout(function () {
                    setTotalExtra(params.value)
                }, 1000);
                break;
            case 3:
                setTimeout(function () {
                    setTotalTransport(params.value)
                }, 1000);
                break;
            case 4:
                setTimeout(function () {
                    setTotalUM(params.value)
                }, 1000);
                break;
            case 5:
                setTimeout(function () {
                    setTotalExtraDays(params.value)
                }, 1000);
                break;
            case 6:
                setTimeout(function () {
                    if (params.value > 0 && params.value < total) {
                        setTotalDiscount(params.value);
                    } else {
                        setTotalDiscount(0)
                    }
                }, 1000);
                break;
            case 7:
                setTimeout(function () {
                    if (params.value > 0 && params.value < total) {
                        setTotalCommission(params.value);
                    } else {
                        setTotalCommission(0)
                    }
                }, 1000);
                break;
        }
        var amount = params.value;
        return { ...params.row, amount };
    }

    const columns = [
        {
            field: 'icon',
            width: '20',
            renderCell: (params) => {
                switch (params.id) {
                    case 1:
                        return <DateRangeIcon color="thirdry" />
                    case 2:
                        return <LocalActivityIcon color="thirdry" />
                    case 3:
                        return <ConnectingAirportsIcon color="thirdry" />
                    case 4:
                        return <EscalatorWarningIcon color="thirdry" />
                    case 5:
                        return <RoundaboutRightIcon color="thirdry" />
                    case 6:
                        return <DiscountIcon color="thirdry" />
                    case 7:
                        return <DiscountIcon color="thirdry" />
                    case 8:
                        return <FunctionsIcon />
                }
            }, cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } }
        },
        {
            field: 'name', editable: false, flex: 1, cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } },
        },
        {
            field: 'amount', type: 'number', editable: edit_mode, valueSetter: setAmount, align: 'right',
            cellClassName: (params) => {
                if (params.id == 8) { return 'total_bold' }
                if (params.id == 10) {
                    return clsx('super-app', {
                        red: params.value > 0,
                        green: params.value <= 0,
                    });
                }
            },
        },
        { field: 'currency', type: 'string', editable: false, width: '10', cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } } }
    ]

    const columns_2 = [
        {
            field: 'icon',
            width: '20',
            renderCell: (params) => {
                switch (params.id) {
                    case 1:
                        return <DateRangeIcon color="thirdry" />
                    case 2:
                        return <LocalActivityIcon color="thirdry" />
                    case 3:
                        return <ConnectingAirportsIcon color="thirdry" />
                    case 4:
                        return <EscalatorWarningIcon color="thirdry" />
                    case 5:
                        return <RoundaboutRightIcon color="thirdry" />
                    case 6:
                        return <DiscountIcon color="thirdry" />
                    case 7:
                        return <DiscountIcon color="thirdry" />
                    case 8:
                        return <FunctionsIcon />
                }
            }, cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } }
        },
        {
            field: 'name', editable: false, flex: 1, cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } },
        },
        { field: 'currency', type: 'string', editable: false, width: '10', cellClassName: (params) => { if (params.id == 8) { return 'total_bold' } } },
        {
            field: 'amount', type: 'number', editable: edit_mode, valueSetter: setAmount, align: 'right',
            cellClassName: (params) => {
                if (params.id == 8) { return 'total_bold' }
                if (params.id == 10) {
                    return clsx('super-app', {
                        red: params.value > 0,
                        green: params.value <= 0,
                    });
                }
            },
        },
    ]





    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            <Typography fontSize={17} fontWeight={'bold'} marginBottom={1} marginTop={1} align="left" sx={{ color: 'primary.main' }}>
                Pricing
            </Typography>
            <div style={{ height: `${(rows.length * 52) + 100}px`, width: '100%' }}>
                <Box
                    sx={{
                        height: '100%',
                        width: '100%',
                        '& .super-app.green': {
                            color: '#00CC66',
                            fontWeight: '600',
                        },
                        '& .total_bold': {
                            fontWeight: 'bold',
                            borderTop: '1px solid black'
                        },
                        '& .super-app.red': {
                            color: '#d47483',
                            fontWeight: '600',
                        },
                    }} >
                    <TableContainer component={Paper} sx={{ height: '100%', width: '100%' }}>

                        <NoHeaderDataGrid
                            rows={rows.filter(r => r != null)}
                            columns={center != null ? (center.currency == 2 ? columns_2 : columns) : columns}
                            experimentalFeatures={{ newEditingApi: true }}
                            rowsPerPageOptions={[]}
                            hideFooter={true}
                            isCellEditable={(params) => params.row.id <= 8}
                        />
                    </TableContainer>
                </Box>

            </div>
        </Paper >)
}

export default PricingDetailsArray